import React, { useRef } from 'react';
import ReactQuill from 'react-quill';
import { MODULES } from '../../constants';
import 'react-quill/dist/quill.snow.css';
import './style.scss';

const TermsAndConditions = (props) => {
  const { 
    showHeader=true,
    setFormData, 
    formData,
    disabled,
  } = props;

  const ref = useRef(null);

  const handleChange = (value) => {
    setFormData({ ...formData, note: value });
  };

  return (
    <>
      {showHeader && <h1 className='heading-36 mb-9'>Terms and Conditions</h1>}

      <div className='textEditor terms-and-conditions flex flex-col gap-3 flex-1 text-14 overflow-auto'>
        <div className='label-16 text-black'>Add Terms and Conditions for your attendees</div>
        <ReactQuill
          id="event-description-editor"
          value={formData?.note} 
          modules={MODULES}
          ref={ref}
          onChange={handleChange}
          readOnly={disabled}
          placeholder="Add specific terms and conditions for this event. Example: 1. Tickets are non-refundable. 2. Entry is allowed only with a valid ticket."
        />  
      </div>

    </>

  ) 
}

export default TermsAndConditions;